module.exports = __webpack_public_path__ + "img/laptop.ad53351a.svg";